import { useCallback } from 'react'
import logoIcon from '@img/logo-icon-green.png'
import { useAppStore } from '@stores'

const useNotification = () => {
  const showNotifications = useAppStore(state => state.showNotifications)

  const triggerNotification = useCallback(
    ({
      message,
      onlyShowIfNotFocused = true,
    }: {
      message: string
      onlyShowIfNotFocused?: boolean
    }) => {
      if (onlyShowIfNotFocused && document.hasFocus()) return
      if (!showNotifications) return

      return new Notification('MDG Statik', {
        body: message,
        icon: logoIcon,
      })
    },
    [showNotifications],
  )

  return { triggerNotification }
}

export default useNotification
